<div class="list-item">
    <div class="item-title">
        <label (click)="openLink(url)">
            <mat-icon
                svgIcon="hub_article"
                class="icon"
            >
            </mat-icon>
            {{title}}
        </label>
    </div>
    <div class="info d-flex flex-row">
        <div class="p-2 item-last-updated">
            <span>{{consts.LABELS.LAST_UPDATED}}</span>
            <span>{{lastUpdatedBy}}</span>
        </div>
        <div class="p-2 item-rating">
            <span>{{consts.LABELS.RATING}}</span>
            <span>{{rating}}</span>
            <mat-icon
                class="star"
                svgIcon="hub_star_filled"
            >
            </mat-icon>
        </div>
        <div class="p-2 item-view-count">
            <span>{{consts.LABELS.VIEW_COUNT}}</span>
            <span>{{viewCount}}</span>
        </div>
    </div>
    <div class="summary">
        <label>{{summary}}</label>
    </div>
    <div class="info additional-data d-flex flex-row">
        <div class="p-2 item-info" *ngFor="let info of additionalInfo">
            <span class="bold">{{info.propertyLabel}}</span>
            <span>{{info.propertyValue}}</span>
        </div>
    </div>
</div>
